import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Features from './components/Features';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import PrivacyPolicy from './page/PrivacyPolicy';
import ApiDocumentation from './page/ApiDocumentation';
import Communication from './page/Communication';
import AIApplication from './page/AIApplication';
import BespokeSoftware from './page/BespokeSoftware';
import ResearchSecurity from './page/ResearchSecurity';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <Navbar />
              <Header />
              <Features />
              <Footer />
            </motion.div>
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/data-deletion" element={<PrivacyPolicy />} />
        <Route path="/api-docs" element={<ApiDocumentation />} />
        <Route path="/communication" element={<Communication />} />
        <Route path="/ai-application" element={<AIApplication />} />
        <Route path="/bespoke-software" element={<BespokeSoftware />} />
        <Route path="/research-security" element={<ResearchSecurity />} />
      </Routes>
    </Router>
  );
}

export default App;
